module.exports = __webpack_public_path__ + "img/aws.a60cb58d.png";